import * as React from 'react';
import { object as PropObject } from 'prop-types';
import { BrowserRouter as Router } from 'react-router-dom';

import { ErrorMessage, Header } from './gs-core/client';
import { User } from './gs-core/common';

import { CommonConfig } from './common/config';
import { Sidebar } from './Sidebar/Sidebar';
import { routes } from './Routes';
import { RoutesRenderer } from './RoutesRenderer';
import { SearchComponent } from './SearchComponent';
import { ServiceRegistry } from './services';
import { Subject } from './common/models';

interface AppProps {
  config: CommonConfig;
  services: ServiceRegistry;
}
interface AppState {
  loading: boolean;
  hasError: boolean;
  showSidebar: boolean;
  contextUser?: User;
}

export default class App extends React.Component<AppProps, AppState> {
  static childContextTypes = { services: PropObject };

  loading = (loading: boolean) => this.setState({ loading });
  sidebar = (showSidebar: boolean) => this.setState({ showSidebar });
  onSubjectChange = (subject: Subject | undefined) => this.setState({ contextUser: subject && subject.user });

  constructor(props: AppProps) {
    super(props);

    this.state = {
      loading: true,
      hasError: false,
      showSidebar: true
    };
  }

  getChildContext() { return { services: this.props.services }; }

  async componentDidCatch(error: Error, info: any): Promise<void> {
    this.setState({ hasError: true });

    return this.props.services.errorLogger.log(error);
  }

  render() {
    const { services } = this.props;
    const { showSidebar, loading } = this.state;

    return (
      <Router>
        <div>
          <Header
            appName={this.props.config.appName}
            env={this.props.config.env}
            helpLink="https://grad.ucdavis.edu/graduate-information-systems#eDocs"
            currentUserService={services.currentUserService}
            prmService={services.prmService}
            jwtStorage={services.jwtStorage}
            errorLogger={services.errorLogger}
            navManager={services.navManager}
            contextUser={this.state.contextUser}
            onLoading={this.loading}
            searchComponent={<SearchComponent />}
          />

          <div className="page-layout-wrapper">
            <div className="sidebar-wrapper">
              <Sidebar show={showSidebar} />
            </div>

            <main className="page-content">
              <ErrorMessage errorLogger={services.errorLogger} loading={loading} onLoading={this.loading} />
              {!this.state.hasError &&
                <RoutesRenderer
                  routes={routes}
                  onLoading={this.loading}
                  onShowSidebar={this.sidebar}
                  onSubjectChange={this.onSubjectChange}
                  errorLogger={services.errorLogger}
                />
              }
            </main>
          </div>

          {this.state.loading && <div className="view-loading"><i className="fa fa-spinner fa-spin" /></div>}

        </div>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.tsx